<template>
  <div class="image-text-nav-selector">
    <div class="item-setting">
      <div class="header-setting">
        <div class="header-setting__tip">最多添加 20 个导航，拖动选中的导航可对其排序</div>
      </div>
      <div class="body-setting">
        <label-editor
          v-model="$$FormData.tabsList"
          :limit="20"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelModuleSelector'
}
</script>

<style scoped>

</style>